import { LOCATION_CITY } from '../../routes';
import customAxios from '../../customAxios';

async function deleteCtiy(_id: string) {
  try {
    return (await customAxios.delete(`${LOCATION_CITY}/${_id}`)).data;
  } catch (error: any) {
    console.error({LOCATION_CITY: error});
  }
}

export default deleteCtiy;
